import UseWebservice from "../../util/UseWebservice";
import ICaptchaService from "./ICaptchaService";
import MockCaptchaService from "./MockCaptchaService";
import WebCaptchaService from "./WebCaptchaService";

export default class CaptchaServiceFactory {
    public static getCaptchaService(): ICaptchaService {
        if(!UseWebservice()) {
            return new MockCaptchaService();
        }
        
        return new WebCaptchaService();
    }
}